<template>
  <div>
    <b-modal
      id="learning-center-block-modal"
      title="Learning Center Block Confirmation"
      hide-footer
    >
      <h5>Are you sure you want to block this driver from the learning center?</h5>

      <div class="mt-3">
        <label for="description">Description:</label>
        <b-form-textarea
          id="description"
          v-model="learningCenterBlockForm.description"
          rows="3"
          placeholder="Enter description"
          :disabled="submitting"
        />
      </div>

      <div class="d-flex mt-2">
        <b-button
          class="mr-2"
          block
          variant="primary"
          :disabled="submitting"
          @click="submitLearningCenterBlock"
        >
          <b-spinner
            v-if="submitting"
            small
          />
          <span v-else>Yes</span>
        </b-button>
        <b-button
          block
          :disabled="submitting"
          variant="danger"
          @click="$bvModal.hide('learning-center-block-modal')"
        >
          No
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import {
  BButton,
  BSpinner,
  BModal,
  BFormTextarea,
} from 'bootstrap-vue'
import {
  errorNotification,
  successNotification,
} from '@/utils/toast-notifications'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
    BFormTextarea,
  },
  props: {
    driver: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const user = computed(() => ctx.root.$store.getters['auth/getLoggedUser'])
    const learningCenterBlockForm = ref({
      driver: ctx.root.$router.currentRoute.params.id,
      inactivationReason: 'ee04031eaf0747aeb79a32d595627d01',
      createdBy: user.value.email,
      alert: false,
      description: '',
    })
    const submitting = ref(false)

    const submitLearningCenterBlock = async () => {
      try {
        submitting.value = true
        await ctx.root.$store.dispatch('driverView/createDriverInactivation', learningCenterBlockForm.value)
        successNotification('Driver successfully blocked from learning center')
        ctx.root.$bvModal.hide('learning-center-block-modal')

        await ctx.root.$store.dispatch('driverView/fetchDriverInactivationList', {
          id: ctx.root.$router.currentRoute.params.id,
          isResolvedInactivation: true,
        })

        await ctx.root.$store.dispatch('driverView/fetchDriverInactivationList', {
          id: ctx.root.$router.currentRoute.params.id,
          isResolvedInactivation: false,
        })
      } catch (err) {
        errorNotification('An error occurred while blocking driver from learning center')
      } finally {
        submitting.value = false
      }
    }

    return {
      submitting,
      submitLearningCenterBlock,
      learningCenterBlockForm,
    }
  },
}
</script>
